import { createAction } from "@reduxjs/toolkit";
import {
  getFAQItemByCategoryActionTypes,
  getListFAQCategoryActionTypes,
  getPortionFAQItemByCategoryActionTypes,
  getPortionListFAQCategoryActionTypes,
} from "./actionTypes";

export const getListFAQCategories = createAction(
  getListFAQCategoryActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const getListFAQCategoriesSuccess = createAction(
  getListFAQCategoryActionTypes.success,
  (payload) => ({
    payload,
  }),
);

export const getListFAQCategoriesFailure = createAction(
  getListFAQCategoryActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

export const resetCategoryItems = createAction(
  getListFAQCategoryActionTypes.reset,
);

export const getPortionListFAQCategory = createAction(
  getPortionListFAQCategoryActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const getPortionListFAQCategorySuccess = createAction(
  getPortionListFAQCategoryActionTypes.success,
  (payload) => ({
    payload,
  }),
);

export const getPortionListFAQCategoryFailure = createAction(
  getPortionListFAQCategoryActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

export const getFAQCategoryItems = createAction(
  getFAQItemByCategoryActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const getFAQCategoryItemsSuccess = createAction(
  getFAQItemByCategoryActionTypes.success,
  (payload) => ({
    payload,
  }),
);

export const getFAQCategoryItemsFailure = createAction(
  getFAQItemByCategoryActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

export const getPortionFAQCategoryItems = createAction(
  getPortionFAQItemByCategoryActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const getPortionFAQCategoryItemsSuccess = createAction(
  getPortionFAQItemByCategoryActionTypes.success,
  (payload) => ({
    payload,
  }),
);

export const getPortionFAQCategoryItemsFailure = createAction(
  getPortionFAQItemByCategoryActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);
